// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1RqMg","col":"styles_col__144m9","fulfillmentStatus":"styles_fulfillmentStatus__31Gu7","emailCol":"styles_emailCol__2aqFm"};